<template>
  <div class="hoist-tabs">
    <NavMenu />
    <div class="tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="任务汇总" name="first"><WorkCollect /> </el-tab-pane>
        <el-tab-pane label="明细列表" name="second"><DetailList /> </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import NavMenu from '../../common/NavMenu'
import WorkCollect from './WorkCollect'
import DetailList from './DetailList'
export default {
  components: {
    NavMenu,
    WorkCollect,
    DetailList
  },
  data() {
    return {
      activeName: 'first'
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    }
  }
}
</script>

<style lang="scss" scoped>
.hoist-tabs {
  background-color: #ececec70;
  height: 100vh;
  .tabs {
    background-color: #fff;
    height: calc(100vh - 100px);
    margin: 10px;
    padding: 0 10px;
  }
}
</style>